import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../components/ReactSelect';
import { FinField, FinInput, FinCheck } from '../../components/FinField';
import { toast } from 'react-toastify';
import '../../css/financeiro-parcela-pagar.css';


export default function CadastroEventoResponsavelCliente({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const [mostrarUsuarioSenha, setMostrarUsuarioSenha] = useState(false);
    const history = useHistory();

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/eventoResponsavelCliente/' + id,
                token: token,
            }).then(response => {
                var dadosRecebidos = response.data.data;

                //transforma dados no formato aceito pelo reactselect
                if (dadosRecebidos.cliente?.constructor !== Array)
                    dadosRecebidos.cliente = [];
                dadosRecebidos.cliente = dadosRecebidos.cliente.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                if (dadosRecebidos.unidadenegocio?.constructor !== Array)
                    dadosRecebidos.unidadenegocio = [];
                dadosRecebidos.unidadenegocio = dadosRecebidos.unidadenegocio.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                if (dadosRecebidos.bu?.constructor !== Array)
                    dadosRecebidos.bu = [];
                dadosRecebidos.bu = dadosRecebidos.bu.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                setDados(dadosRecebidos);
                // Se houver email ou senha, ativa o toggle
                if (dadosRecebidos.email || dadosRecebidos.senha) {
                    setMostrarUsuarioSenha(true);
                }
            }).catch(err => {
                //console.log(err)
            }).finally(() => { setIsLoading(false); });
        } else {
            setIsLoading(false);
        }
    };

    const salvar = () => {

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        const dadosParaSalvar = { ...dados };

        if (dadosParaSalvar.cliente && Array.isArray(dadosParaSalvar.cliente)) {
            dadosParaSalvar.cliente = dadosParaSalvar.cliente.map(item => item.value).join(',');
        }

        if (dadosParaSalvar.unidadenegocio?.constructor === Array) {
            dadosParaSalvar.unidadenegocio = dadosParaSalvar.unidadenegocio.map(item => item.value).join(',');
        }

        if (dadosParaSalvar.bu?.constructor === Array) {
            dadosParaSalvar.bu = dadosParaSalvar.bu.map(item => item.value).join(',');
        }

        // Remove email e senha se o toggle estiver desativado
        if (!mostrarUsuarioSenha) {
            delete dadosParaSalvar.email;
            delete dadosParaSalvar.senha;
        }

        if (id) {//update
            api({
                method: 'put',
                action: '/eventoResponsavelCliente/' + id,
                token: token,
                data: dadosParaSalvar
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/eventoResponsavelCliente");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {//insert
            api({
                method: 'post',
                action: '/eventoResponsavelCliente',
                token: token,
                data: { ...dadosParaSalvar, ...{ empresa: empresa } }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/eventoResponsavelCliente");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus();
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Responsável Cliente</h1>
                    </div>
                </div>

                <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: '16px', marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField grow label="Cliente">
                                <ReactSelect
                                    isMulti={true}
                                    value={dados.cliente}
                                    onChange={(e) => {
                                        dados.cliente = dados.cliente || [];
                                        dados.cliente = e;
                                        setDados({ ...dados });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/participante',
                                            token: token,
                                            params: {
                                                nome: input,
                                                tipoCadastro: "cliente",
                                                situacaoRegistro: "ativo"
                                            }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map((registro) => {
                                                    var label = registro.codigo +
                                                        ' - ' + registro.nome +
                                                        (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                        (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                        (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                        (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                    return {
                                                        value: registro.id,
                                                        label: label
                                                    };
                                                });
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                        </div>

                        <div className="fin-pp__filters" style={{ marginTop: 16 }}>
                            <FinField grow label="Unidade de Negócios">
                                <ReactSelect
                                    isMulti={true}
                                    value={dados.unidadenegocio ?? []}
                                    onChange={(e) => {
                                        dados.unidadenegocio = dados.unidadenegocio || [];
                                        dados.unidadenegocio = e;
                                        setDados({ ...dados });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/produtoUnidadeNegocio',
                                            token: token,
                                            params: { nome: input }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            <FinField grow label="BU">
                                <ReactSelect
                                    isMulti={true}
                                    value={dados.bu ?? []}
                                    onChange={(e) => {
                                        dados.bu = dados.bu || [];
                                        dados.bu = e;
                                        setDados({ ...dados });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/produtoBu',
                                            token: token,
                                            params: {
                                                nome: input,
                                            }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                        </div>

                        <div className="fin-pp__filters" style={{ marginTop: 16 }}>
                            <FinField full label="Nome">
                                <FinInput type="text" id="nome" placeholder="Nome"
                                    value={dados.nome}
                                    onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                />
                            </FinField>
                        </div>

                        <div className="fin-pp__filters" style={{ marginTop: 16 }}>
                            <div style={{ flex: '1 1 100%' }}>
                                <FinCheck
                                    id="mostrarUsuarioSenha"
                                    label="Cadastrar usuário e senha"
                                    checked={mostrarUsuarioSenha}
                                    onChange={(e) => {
                                        const ativado = e.target.checked;
                                        setMostrarUsuarioSenha(ativado);
                                        if (!ativado) {
                                            setDados({ ...dados, email: '', senha: '' });
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        {mostrarUsuarioSenha && (
                            <div className="fin-pp__filters" style={{ marginTop: 16 }}>
                                <FinField grow label="Usuário (E-mail)">
                                    <FinInput type="text" id="email" placeholder="Usuário"
                                        value={dados.email}
                                        onChange={e => setDados({ ...dados, ...{ "email": e.target.value } })}
                                    />
                                </FinField>
                                <FinField grow label="Senha">
                                    <FinInput type="password" id="senha" placeholder="Senha"
                                        value={dados.senha}
                                        onChange={e => setDados({ ...dados, ...{ "senha": e.target.value } })}
                                    />
                                </FinField>
                            </div>
                        )}
                    </div>

                    <div className="row fixoRodape">
                        <div className="col-12 d-flex justify-content-end">
                            <button
                                type="submit"
                                className="fin-pp__btn fin-pp__btn--primary"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Salvando...
                                    </>
                                ) : (
                                    <><FaSave size={16} /> Salvar</>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
